import React, { useEffect, useState } from "react";
import TurnSummaryCard from "../../components/cards/turnSummaryCard";
// import data from "../../components/test json data/turnSummery.json";
import IsLogin from "../../utilities/functions/isLogin";
import { Link, useNavigate } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import constData from "../../utilities/const.json";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import scrollToTop from "../../utilities/functions/ScrollToTop";

const MyTurns = () => {
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const navigate = useNavigate();
  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };
  const [MyTurnsloading, setMyTurnsLoading] = useState(false);

  const [MyTurns, setMyTurns] = useState();

  const [cardSelection, setCardSelection] = useState();

  // #region pages variables
  const [searchValue, setSearchValue] = useState("");
  const [paginationElem, setPaginationElem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const maxVisiblePages = 5; // Adjust this value as needed
  //  #endregion

  const myTurnsAPI = () => {
    setMyTurnsLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.dashboardControllers.showMyEvents +
        "?page=" +
        currentPage,
        {
          per_page: perPage,
          ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
          pagination: true,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setMyTurnsLoading(false);
        if (response.data.status === "success") {
          setMyTurns([]);
          if (response.data.data.events) {
            // !IMPORTANT, You should use element.map() function rather than this shit! (Forgive my rudeness)
            setMyTurns(response.data.data.events);

            // pagination
            const paginationItems = [];
            const totalPages = response.data.data.page_count;

            if (totalPages > 1) {
              // Calculate the range of pages to display
              const startPage = Math.max(
                1,
                currentPage - Math.floor(maxVisiblePages / 2)
              );
              let endPage = Math.min(
                totalPages,
                startPage + maxVisiblePages - 1
              );

              // Add previous button if not on the first page
              if (currentPage !== 1) {
                paginationItems.push(
                  <li key="prev" className="page-item">
                    <Link
                      className="page-link 7"
                      to={window.location.href}
                      onClick={() => {
                        setCurrentPage(currentPage - 1);
                        scrollToTop();
                      }}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </Link>
                  </li>
                );
              }
              // Add first button if not on the first page
              if (currentPage !== 1 && currentPage !== 2) {
                paginationItems.push(
                  <li key="first" className="page-item">
                    <Link
                      className="page-link 6"
                      to={window.location.href}
                      onClick={() => {
                        setCurrentPage(1);
                        scrollToTop();
                      }}
                    >
                      1
                    </Link>
                  </li>
                );
              }

              // Add ellipsis before first page if necessary
              if (startPage > 1) {
                paginationItems.push(
                  <li key="ellipsis1" className="page-item disabled">
                    <span className="page-link 5">...</span>
                  </li>
                );
              }

              // Add page numbers
              for (let i = startPage; i < endPage; i++) {
                paginationItems.push(
                  <li
                    key={i}
                    className={
                      "page-item 4" + (currentPage === i ? " active" : "")
                    }
                  >
                    <Link
                      className="page-link 1"
                      to={window.location.href}
                      onClick={() => {
                        setCurrentPage(i);
                        scrollToTop();
                      }}
                    >
                      {i}
                    </Link>
                  </li>
                );
              }

              // Add ellipsis after last page if necessary
              if (endPage < totalPages) {
                paginationItems.push(
                  <li key="ellipsis2" className="page-item disabled">
                    <span className="page-link 2">...</span>
                  </li>
                );
              }

              // Add last button if not on the last page

              paginationItems.push(
                <li key="last" className="page-item">
                  <Link
                    className={`page-link${currentPage !== totalPages ? "" : " active"
                      }`}
                    to={window.location.href}
                    onClick={() => {
                      setCurrentPage(totalPages);
                      scrollToTop();
                    }}
                  >
                    {totalPages}
                  </Link>
                </li>
              );

              // Add next button if not on the last page
              if (currentPage !== totalPages) {
                paginationItems.push(
                  <li key="next" className="page-item">
                    <Link
                      className="page-link"
                      to={window.location.href}
                      onClick={() => {
                        setCurrentPage(currentPage + 1);
                        scrollToTop();
                      }}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </Link>
                  </li>
                );
              }
              setPaginationElem(paginationItems);
            } else {
              setPaginationElem();
            }
            // end pagination
          } else {
            setPaginationElem();
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setMyTurnsLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  // login checher useEffect
  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      if (loggedIn === false || loggedIn === "error api") {
        // localStorage.clear();
        localStorage.getItem("FullName") && localStorage.removeItem("FullName");
        localStorage.getItem("mobile") && localStorage.removeItem("mobile");
        localStorage.getItem("token") && localStorage.removeItem("token");
        localStorage.setItem(
          "callBackURL",
          window.location.pathname + window.location.search
        );
        navigate("/login");
      } else if (haveAccess(loggedIn, "myturns_page")) {
        // myTurnsAPI();
      } else {
        localStorage.setItem(
          "callBackURL",
          window.location.pathname + window.location.search
        );
        navigate("/login");
      }
    };

    checkLoginStatus();
  }, []);

  // pagination
  useEffect(() => {
    myTurnsAPI();
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    myTurnsAPI();
  }, [searchValue, perPage]);
  // [searchValue, perPage]
  // pagination

  return (
    <div>
      <div className="d-flex align-items-center pt-3 mb-2">
        <h5 className="my-3 col-auto me-2">خلاصه نوبت‌های من</h5>
        <div className="d-flex ms-auto">
          <input
            className="form-control ms-1 col"
            type="text"
            placeholder="جستجو ..."
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
          />
        </div>
      </div>
      {MyTurnsloading && (
        <span
          className="spinner-border spinner-border ms-1"
          role="status"
          aria-hidden="true"
        />
      )}
      <div className="d-flex row g-3">
        {haveAccess(roles, "myturns_page") &&
          MyTurns &&
          MyTurns.map((element, index) => (
            <div
              className="col-lg-6 col-12"
              key={index}
              onClick={() => {
                setCardSelection(element.event_id);
              }}
            >
              <TurnSummaryCard
                turnID={element.event_id}
                date={element.date}
                day={element.day}
                time={element.time}
                lastStatus={element.status}
                patientFirstName={element.patient_first_name}
                patientLastName={element.patient_last_name}
                patientTel={element.patient_mobile}
                doctorTitle={element.doctor_title}
                doctorFirstName={element.doctor_first_name}
                doctorLastName={element.doctor_last_name}
                placeTitle={element.place_title}
                departmentTitle={element.department_title}
                turnType={element.type}
                payment={element.pay_status}
                byWho={
                  (element.creator_first_name &&
                    element.creator_first_name + " ") +
                  (element.creator_last_name &&
                    element.creator_last_name + " ") +
                  (element.creator_role &&
                    " | " + constData.roleName[element.creator_role.toString()])
                }
                clicked={element.event_id == cardSelection}
                doctorID={element.doctor_id}
                departmentID={element.department_id}
                placeID={element.place_id}
                onChange={() => {
                  myTurnsAPI();
                }}
                actionAccess={false}
              />
            </div>
          ))}
        <nav aria-label="Page navigation">
          <ul className="pagination">{!MyTurnsloading && paginationElem}</ul>
        </nav>
      </div>
    </div>
  );
};

export default MyTurns;
